import { PlanVariantTier, SubscriptionInterval } from '../types/api/SubscriptionTypes';
import { ProductFilterConfig } from '../types/ui/productFilters';

import { ModelsIcon, MotionIcon, VDBIcon } from '../modules/Icons';

import { LIBRARY_IDS } from './api';

export const NOTIFICATION_HEIGHT_PX = 80;
export const NOTIFICATION_WIDTH_PX = 461;
export const NOTIFICATION_MARGIN_TOP_PX = 16;
export const NOTIFICATION_DURATION_SEC = 10;

export const RESET_COPY_TO_CLIPBOARD_BUTTON_UI_INTERVAL = 10;

export const ANIMATE_FRAME_REFRESH_INTERVAL = 80;

export const EMAIL_NOT_VERIFIED_MESSAGE =
  'Your email address is not verified yet. This means you are not able to download any content. Please check your email inbox and verify the email address!';

export const MAX_WISHLIST_ITEMS_COUNT = 50;

export const MAX_PFL_DOWNLOADS_COUNT = 10;

export const NOTIFICATION_STYLE = {
  marginTop: `${NOTIFICATION_MARGIN_TOP_PX.toString()}px`,
  height: `${NOTIFICATION_HEIGHT_PX}px`,
  width: `${NOTIFICATION_WIDTH_PX}px`,
  marginRight: '32px',
  overflow: 'hidden',
  display: 'block'
};

export const NOTIFICATION_MOBILE_STYLE = {
  marginTop: `${NOTIFICATION_MARGIN_TOP_PX.toString()}px`,
  height: `${NOTIFICATION_HEIGHT_PX}px`,
  width: `calc(100vw - 16px)`,
  marginRight: '8px',
  marginLeft: '8px'
};

export const homepageBackgroundImageSource = 'https://a-us.storyblok.com/f/1002378/1920x700/9dcc42a9b1/front_page_static_banner.jpg';
export const homepageBackgroundVideoSource = 'https://a-us.storyblok.com/f/1002378/x/1f6178b540/actionvfxfrontpage15.mp4';

export const PAY_BY_CARD_BUTTON_TEXT = 'Confirm & Pay';
export const CONFIRM_FREE_PURCHASE_BUTTON_TEXT = 'Confirm';
export const PAY_BY_PAYPAL_BUTTON_TEXT = 'Continue to PayPal';

export const SECONDS_BEFORE_REDIRECT = 5 * 1000;

export const REGULAR_PRICING_PAGE_URL = '/pricing';
export const ENTERPRISE_PRICING_PAGE_URL = '/pricing/enterprise';

export const HOW_DO_PLANS_WORK_VIDEO_URL =
  'https://www.youtube.com/embed/iPvEJsC8RwE?si=agxP_lZxP_m14Zhu&autoplay=1&mute=1';

export const DEFAULT_PLAN_VARIANT_TIER_SELECTION: PlanVariantTier = 'basic';
export const DEFAULT_PLAN_VARIANT_INTERVAL_SELECTION: SubscriptionInterval = 'year';

export const CART_CONSTANTS = {
  BUNDLE_DISCOUNT_MIN_ITEMS_COUNT: 5,
  BUNDLE_DISCOUNT_PRODUCT_NAME: '20% Off Bundle Discount',
  BUNDLE_DISCOUNT_PERCENT: 20,
};

export const PRODUCT_FILTER_KEYS = {
  TEXT_SEARCH_V1: 'search',
  TEXT_SEARCH_V2: 'search_query',
  SORT_BY: 'sort_by',
  ASSET_TYPE: 'asset_type',
}

export const PRODUCT_FILTERS: { [key: number]: ProductFilterConfig } = {
  [LIBRARY_IDS.LIBRARY_ID_2D]: {
    options: [
      { name: 'Most Popular', queryParamKey: PRODUCT_FILTER_KEYS.SORT_BY, queryParamValue: '' },
      { name: 'Newest', queryParamKey: PRODUCT_FILTER_KEYS.SORT_BY, queryParamValue: 'newest' },
    ],
  },
  [LIBRARY_IDS.LIBRARY_ID_3D]: {
    options: [
      { name: 'All', queryParamKey: PRODUCT_FILTER_KEYS.ASSET_TYPE, queryParamValue: '' },
      { name: '3D Models', queryParamKey: PRODUCT_FILTER_KEYS.ASSET_TYPE, queryParamValue: '3D Model', icon: ModelsIcon },
      { name: 'Animated', queryParamKey: PRODUCT_FILTER_KEYS.ASSET_TYPE, queryParamValue: 'Animated', icon: MotionIcon },
      { name: 'VDB', queryParamKey: PRODUCT_FILTER_KEYS.ASSET_TYPE, queryParamValue: 'VDB', icon: VDBIcon },
    ],
  },
};

export const BUNDLE_FILTER_KEYS = {
  SORT_BY: 'sort_by',
  LIBRARY_ID: 'library_id',
  SEARCH_QUERY: 'search_query',
  PAGE: 'page',
} as const;

export const BUNDLE_FILTER_VALUES = {
  DEFAULT: '',
  NEWEST_HIGH_TO_LOW: 'newest',
  NEWEST_LOW_TO_HIGH: 'newest_low_to_high',
  EFFECTIVE_DISCOUNT_HIGH_TO_LOW: 'effective_discount',
  EFFECTIVE_DISCOUNT_LOW_TO_HIGH: 'effective_discount_low_to_high',
};

export const BUNDLES_INDEX_FILTER_CONFIG: ProductFilterConfig = {
  options: [
    { name: 'Default', queryParamKey: BUNDLE_FILTER_KEYS.SORT_BY, queryParamValue: BUNDLE_FILTER_VALUES.DEFAULT },
    { name: 'Date added (new to old)', queryParamKey: BUNDLE_FILTER_KEYS.SORT_BY, queryParamValue: BUNDLE_FILTER_VALUES.NEWEST_HIGH_TO_LOW },
    { name: 'Date added (old to new)', queryParamKey: BUNDLE_FILTER_KEYS.SORT_BY, queryParamValue: BUNDLE_FILTER_VALUES.NEWEST_LOW_TO_HIGH },
    { name: 'Discount (high to low)', queryParamKey: BUNDLE_FILTER_KEYS.SORT_BY, queryParamValue: BUNDLE_FILTER_VALUES.EFFECTIVE_DISCOUNT_HIGH_TO_LOW },
    { name: 'Discount (low to high)', queryParamKey: BUNDLE_FILTER_KEYS.SORT_BY, queryParamValue: BUNDLE_FILTER_VALUES.EFFECTIVE_DISCOUNT_LOW_TO_HIGH },
  ],
};

export const BUNDLES_INDEX_DEFAULT_FILTER = BUNDLES_INDEX_FILTER_CONFIG.options[0];

export const TEXT_SEARCH_DEBOUNCE_MS = 500;

export const productPageCarouselOptions = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  arrows: false,
  fade: true,
  speed: 300,
  overflow: 'hidden'
};
